<template>
  <div>
    <v-dialog v-model="show" persistent max-width="90%">
      <v-card>
        <v-app-bar dense dark text color="secondary">
          <v-toolbar-title class="subheading">{{ $t("users.title") }}</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
            <v-container grid-list-md>
              <v-layout>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('global.search')"
                    v-model="search_params.any"
                    @keydown="checkKeyPress"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <action-button type="save" @click="submit" small />
          <action-button type="cancel" @click="cancel" small />
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-data-table
            :headers="headers"
            :items="users"
            :items-per-page="users.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
            :show-select="true"
            v-model="selected"
            item-key="id"
          >
            <template v-slot:item.first_name="{ item }">
              {{ item.person.first_name }}
            </template>

            <template v-slot:item.last_name="{ item }">
              {{ item.person.last_name }}
            </template>

            <template v-slot:item.email="{ item }">
              {{ item.email }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "UsersListPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    title: {
      type: String
    },
    single_select: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
    },
    company_id: {
      type: Number
    },
  },

  data() {
    return {
      url: "",
      
      selected: [],
      users: [],

      total: 0,
      all_ids: [],
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"],
        sortDesc: []
      },
      search_params: {
        any: "",
        company_id: "",
      },
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("users.first_name"), value: "first_name" },
          { text: this.$t("users.last_name"), value: "last_name" },
          { text: this.$t("users.email"), value: "email" }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) this.refresh = true
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.selected = []
          this.users = []
          this.list()
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "users"
  },

  methods: {
    list() {
      this.show_loading = true

      if(this.company_id) {
        this.search_params.company_id = this.company_id
      }

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      if(this.role) {
        query += "&role=" + this.role
      }

      axios.get(this.url + "?" + query).then((res) => {
        this.users = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false
        this.all_ids = res.data.meta.all_ids

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })

      this.ddlist_filter()
    },

    ddlist_filter() {
      /*axios.post(this.API_URL + "request/ddlists", [{ key: "coursetypes", module: "coursetypes", query: "show_all=true" }]).then((res) => {
        this.coursetypes_filter = res.data.coursetypes
      })*/
    },
    filter(target) {
      this.refresh = true
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    reset() {
      this.$refs.form.reset()
      this.refresh = true
    },

    cancel() {
      this.$emit("callback_userlistpopup_cancel")
      this.reset()
    },

    submit() {
      let vm = this

      if (this.selected.length == 0) {
        this.$awn.alert(vm.$t("courses.no_course_selected"))
      } else {
        this.$emit("callback_userlistpopup_submit", this.selected)
      }

      this.reset()
    }
  }
}
</script>

<style scoped></style>
